((scope)=>{
  const key='mcginley-quote-v1', limit=100;
  const valid=line=>line&&typeof line.title==='string'&&typeof line.details==='string'&&(line.total===null||(Number.isFinite(line.total)&&line.total>0));
  const createStore=getStorage=>{
    const read=()=>{
      const raw=getStorage().getItem(key), lines=raw?JSON.parse(raw):[];
      if(!Array.isArray(lines)||!lines.every(valid)||lines.length>limit) throw Error('basket_unreadable');
      return lines.map(line=>line.kind==='durban-design'?{...line,title:line.title.replace(/^Durban modular sofa design/,'Cairo modular sofa design'),details:line.details.replace(/^Durban modular sofa design/,'Cairo modular sofa design')}:line);
    };
    // Read immediately before each write so an older tab cannot overwrite newer items.
    const add=line=>{
      if(!valid(line)) throw Error('basket_invalid');
      const lines=read();if(lines.length>=limit)throw Error('basket_full');
      const item={...line,quoteId:scope.crypto?.randomUUID?.()||Date.now().toString(36)+'-'+Math.random().toString(36).slice(2)};
      lines.push(item);getStorage().setItem(key,JSON.stringify(lines));if(typeof scope.dispatchEvent==='function')scope.dispatchEvent(new Event('mcginley:quote-changed'));return lines;
    };
    const remove=line=>{
      const lines=read(),index=lines.findIndex(p=>line.quoteId?p.quoteId===line.quoteId:JSON.stringify(p)===JSON.stringify(line));
      if(index>=0){lines.splice(index,1);getStorage().setItem(key,JSON.stringify(lines));if(typeof scope.dispatchEvent==='function')scope.dispatchEvent(new Event('mcginley:quote-changed'));}return lines;
    };
    return {read,add,remove};
  };
  if(typeof module!=='undefined'&&module.exports)module.exports={createStore,key,limit};
  else scope.McGinleyQuoteBasket={createStore,key,limit};
})(typeof globalThis!=='undefined'?globalThis:this);